var map = {
	"./circle_black.svg": 464,
	"./circle_blue.svg": 465,
	"./ellipse_black.svg": 466,
	"./france.svg": 282,
	"./highlighted_yellow.svg": 467,
	"./icone/carousel_new.svg": 512,
	"./icons/Cart.svg": 513,
	"./icons/Cart_add.svg": 514,
	"./icons/Cart_delete.svg": 515,
	"./icons/Cart_remove.svg": 516,
	"./icons/_info.svg": 517,
	"./icons/add_icon.svg": 286,
	"./icons/add_prod.svg": 518,
	"./icons/add_prodOLD.svg": 519,
	"./icons/ask.svg": 520,
	"./icons/carousel.svg": 358,
	"./icons/carrello.svg": 521,
	"./icons/categorie.svg": 522,
	"./icons/clear_chart.svg": 523,
	"./icons/close.svg": 201,
	"./icons/close_.svg": 524,
	"./icons/condividi.svg": 525,
	"./icons/email.svg": 360,
	"./icons/facebook.svg": 198,
	"./icons/hatchef.svg": 349,
	"./icons/icone/_info.svg": 526,
	"./icons/icone/book-open-solid.svg": 342,
	"./icons/icone/columns-solid.svg": 343,
	"./icons/icone/file-pdf-solid.svg": 345,
	"./icons/icone/hatchef.svg": 527,
	"./icons/icone/info.svg": 528,
	"./icons/icone/list-solid.svg": 348,
	"./icons/icone/magnifying-glass-solid.svg": 344,
	"./icons/icone/play.svg": 529,
	"./icons/icone/plus.svg": 530,
	"./icons/icone/share-square-solid-prod.svg": 347,
	"./icons/icone/share-square-solid.svg": 346,
	"./icons/icone/specs.svg": 531,
	"./icons/icone/world.svg": 532,
	"./icons/index-icon-bookmark.svg": 533,
	"./icons/index-icon.svg": 534,
	"./icons/info.svg": 357,
	"./icons/informazioni.svg": 535,
	"./icons/internal_link.svg": 361,
	"./icons/mappa.svg": 536,
	"./icons/markers-SVG/ask.svg": 537,
	"./icons/markers-SVG/info.svg": 538,
	"./icons/markers-SVG/list.svg": 539,
	"./icons/markers-SVG/recipe.svg": 540,
	"./icons/markers-SVG/web.svg": 541,
	"./icons/pagine.svg": 542,
	"./icons/pdf.svg": 543,
	"./icons/play.svg": 353,
	"./icons/play_ip.svg": 354,
	"./icons/plus.svg": 350,
	"./icons/plus_ip.svg": 351,
	"./icons/prodotti.svg": 544,
	"./icons/promo.svg": 356,
	"./icons/promo2.svg": 545,
	"./icons/promo3.svg": 546,
	"./icons/promo_10.svg": 547,
	"./icons/promo_classic.svg": 548,
	"./icons/remove_prod.svg": 549,
	"./icons/remove_prodOLD.svg": 550,
	"./icons/remove_prod_.svg": 551,
	"./icons/ricetta.svg": 552,
	"./icons/schermo_intero.svg": 553,
	"./icons/shop_list.svg": 554,
	"./icons/specs.svg": 355,
	"./icons/telephone.svg": 359,
	"./icons/video.svg": 555,
	"./icons/volantino.svg": 556,
	"./icons/whatsapp.svg": 199,
	"./icons/world.svg": 352,
	"./logo_catalog_interattivo.svg": 558,
	"./logo_interattivo.svg": 560,
	"./logo_interattivo_free.svg": 562,
	"./logo_interattivo_new.svg": 380,
	"./logo_menu_interattivo.svg": 563,
	"./logo_volantinointerattivo_free.svg": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;